import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiReferensiPembayaranPiutangService = new CrudCustom('/transaksi-referensi-pembayaran-piutangs');
export default TransaksiReferensiPembayaranPiutangService;
